console.log(`




 
                  @@@@@@@@    @@@@         @@@@  @@@@@@@@@@@@    @@@@ @@@@@@@@@@@@@@@@              
               @@@@@@@@@@@@@@ @@@@@       @@@@@ @@@@@@@@@@@@@@@  @@@@ @@@@@@@@@@@@@@@@              
              @@@@        @@@@  @@@@     @@@@   @@@@       @@@@  @@@@       @@@@                    
              @@@@@@@@           @@@@@ @@@@@    @@@@      @@@@@  @@@        @@@@                    
               @@@@@@@@@@@@@@@     @@@@@@@@     @@@@@@@@@@@@@    @          @@@@                    
                         @@@@@      @@@@@       @@@@        @@@@ @@@        @@@@                    
              @@@@         @@@       @@@@       @@@@        @@@@ @@@@       @@@@                    
               @@@@@@@@@@@@@@@       @@@@       @@@@@@@@@@@@@@@  @@@@       @@@@                    
                  @@@@@@@@@          @@@@        @@@@@@@@@@@@    @@@@       @@@@               


              Wenn Du das hier liest, bewirb Dich jetzt:

              https://sybit.com/de/karriere




			  
`);



/**
 * Resize Animation Stopper
 *
 * This code adds a class to the body element during window resizing
 * to temporarily disable all animations and transitions. This helps
 * reduce visual jank and improve performance when resizing the window,
 * especially on pages with many animated elements.
 *
 * The class is removed shortly after resizing stops, allowing
 * animations to resume during normal page interaction.
 */
let resizeTimer;
window.addEventListener('resize', () => {
  document.body.classList.add('resize-animation-stopper');
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.body.classList.remove('resize-animation-stopper');
  }, 400);
});

/**
 * This script uses the IntersectionObserver API to observe elements with the attribute
 * `in-viewport-observer`. When the element enters the viewport (at least 10% visible),
 * it dynamically adds the attribute `in-viewport` to the element.
 *
 * When the element leaves the viewport, the `in-viewport` attribute is removed.
 *
 * Usage:
 * 1. Add `in-viewport-observer` (without a value) to any HTML element you want to observe.
 * 2. The script will automatically observe those elements and toggle the `in-viewport` attribute
 *    when the element becomes visible or invisible within the viewport.
 * 3. If the element once entered the viewport, it will also have the attribute `was-in-viewport`.
 *
 * Example:
 * <div in-viewport-observer></div>
 *
 * CSS can be used to style the elements based on whether they are in the viewport:
 * [in-viewport] {
 *     opacity: 1;
 *     background-color: lightgreen;
 * }
 *
 * CSS can be used to style elements which were in the viewport at least once:
 * [was-in-viewport] {
 *    background-color: lightblue;
 * }
 *
 * Customize the observer's threshold, root, or behavior by modifying the observerOptions.
 */

document.addEventListener('DOMContentLoaded', () => {
  const observerOptions = {
    root: null, // viewport as root
    threshold: 0.1, // 10% of the element must be visible to trigger
  };

  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.setAttribute('in-viewport', 'true');
        entry.target.setAttribute('was-in-viewport', 'true');
      } else {
        entry.target.removeAttribute('in-viewport');
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  document.querySelectorAll('[in-viewport-observer]').forEach((element) => {
    observer.observe(element);
  });
});

import '@oddbird/popover-polyfill';
import baffle from 'baffle';

import './blocks/key-facts/count-up.js';
import './blocks/vertical-tab/SpicySections.js';
import './blocks/site-header/reveal-header.js';
import './blocks/slide-out-navigation/collapsible-list.js';
import './blocks/media-carousel/media-carousel.js';
import './blocks/site-header/flyout-menu.js';
import './blocks/job-offers/job-offer-filter.js';
import './blocks/logo-stripe/logo-stripe.js';
import './blocks/sine-wave-arrow/sine-wave-arrow.js';
import './features/case-studies/index.js';
import './features/events/index.js';

document.addEventListener('DOMContentLoaded', () => {
  let el = document.querySelector('h1 > strong');
  if (el) {
    let b = baffle(el, {
      characters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789#%&!?@',
    });
    b.reveal(4000);
  }
});
